<template>
  <ul class="rules" :class="{ mobile: isMobile }">
    <li v-if="triggerOnFirstHit">
      Prefix(es) to send hit(s) for the first time.
    </li>
    <li v-if="triggerOnNumHits !== null && triggerOnNumHits !== undefined">
      Prefix(es) to send the same or more than
      {{ triggerOnNumHits }} hit(s) within a day.
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Rules',
  props: {
    triggerOnNumHits: {
      required: true
    },
    triggerOnFirstHit: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  }
};
</script>

<style lang="scss" scoped>
.rules {
  padding: 1rem;
  padding-bottom: 0;

  li {
    margin-bottom: 0.5rem;
  }
}

.mobile {
  &.rules {
    li {
      margin-bottom: 0;
      padding-bottom: 1rem;
    }
  }
}
</style>
